/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('home', {
      url: '/home?app,client_id,client_secret,redirect_uri,continue,response_type,www_login,membership_amount,membership_type',
      template: '<home></home>',
      data: { pageTitle: 'Home' },
    });
}



// WEBPACK FOOTER //
// ./client/app/home/home.routes.js